import React, {useEffect, useState} from 'react';
import {useNavigate, useParams, useSearchParams} from 'react-router-dom';
import {fetchMembershipStripeLinkWithAnalytics} from '../utils/membershipCheckout';
import useAuth from '../hooks/useAuth';
import {isMobile} from '../utils/deviceCheck';

const MembershipDirectCheckout = () => {
  const {user} = useAuth();
  const [stripeLoading, setStripeLoading] = useState(true);
  const navigate = useNavigate();
  const {membershipId} = useParams();

  useEffect(() => {
    if (user) {
      if (user?.activeMembershipPlan?.id == membershipId || !Number(membershipId)) {
        navigate('/home');
        return;
      } else if (!(isMobile || window['ReactNativeWebView'])) {
        navigate('/download');
        return;
      }
      setStripeLoading(true);
      
      const handleCheckout = async () => {
        fetchMembershipStripeLinkWithAnalytics({
          membershipId: Number(membershipId),
        }).then((ret) => {
          if (ret.data.link) {
            window.location.href = ret.data.link;
          } else {
            setStripeLoading(false);
          }
        });
      };
      
      handleCheckout();
    }
  }, [user, membershipId]);

  return <></>;
};

export default MembershipDirectCheckout;
